import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { NAV } from "../constants/testIds";

const links = [
  { to: "/shop", label: "Shop Systems", tid: NAV.shop },
  { to: "/refills", label: "Refills", tid: NAV.refills },
  { to: "/lookbook", label: "Lookbook", tid: NAV.lookbook },
  { to: "/finder", label: "Procedure Finder", tid: NAV.finder },
  { to: "/clinics", label: "For Clinics", tid: "nav-clinics" },
  { to: "/faq", label: "FAQ", tid: NAV.faq },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FBF6F1]/85 border-b border-[#F0DFD0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 flex items-center justify-between h-20">
        <Link to="/" data-testid={NAV.logo} className="flex items-baseline gap-2">
          <span className="font-serif text-2xl tracking-tight">ALTA</span>
          <span className="font-mono text-[0.65rem] tracking-[0.32em] uppercase text-[#B85C56] mt-1">Recovery</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.tid}
              className={({ isActive }) =>
                `nav-link tracking-wide ${isActive ? "text-[#2A1F1F] font-medium" : "text-[#4A3535]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid={NAV.cartBtn}
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 px-3 py-2 hover:bg-[#FDF3ED] transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid={NAV.cartCount}
                className="absolute -top-1 -right-1 bg-[#2A1F1F] text-[#FEFBF9] text-[10px] w-5 h-5 rounded-full flex items-center justify-center font-mono"
              >
                {count}
              </span>
            )}
          </button>
          <button
            data-testid={NAV.mobileMenu}
            className="md:hidden p-2"
            onClick={() => setMobile((v) => !v)}
            aria-label="Menu"
          >
            {mobile ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {mobile && (
        <div className="md:hidden border-t border-[#F0DFD0] bg-[#FBF6F1]">
          <div className="px-4 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setMobile(false)}
                className="text-base text-[#4A3535]"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
